import React, { useState } from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import { rgba } from "polished";
import {
  Title,
  Section,
  Box,
  Text,
  Badge,
  Button,
  Switch,
} from "../../components/Core";
import { device } from "../../utils";

const SectionStyled = styled(Section)`
  position: relative;
  &::after {
    content: "";
    left: 0;
    bottom: 0;
    height: 30%;
    width: 100%;
    position: absolute;
    background: ${({ theme }) => theme.colors.dark}!important;
  }
`;

const ULStyled = styled.ul`
  list-style: none;
  max-width: 350px;
  margin: 30px auto 0 15px;
  padding-left: 0;

  @media ${device.sm} {
    display: flex;
    flex-wrap: wrap;
    margin: 30px auto 0;
  }
  @media ${device.lg} {
    justify-content: space-between;
    margin: 30px auto 0 15px;
  }

  li {
    color: #19191b;
    font-size: 21px;
    font-weight: 300;
    letter-spacing: -0.66px;
    line-height: 50px;
    display: flex;
    margin-bottom: 5px;

    &:before {
      content: "\f00c";
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
      display: inline-block;
      font-size: 13px;
      width: 30px;
      height: 30px;
      background-color: ${({ theme }) => rgba(theme.colors.secondary, 0.1)};
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 500px;
      color: ${({ theme }) => theme.colors.secondary};
      position: relative;
      top: 9px;
      margin-right: 13px;
    }
  }
`;

const CardPricing = styled(Box)`
  box-shadow: ${({ theme }) =>
    `0 52px 54px ${rgba(theme.colors.shadow, 0.125)}`};
  border-radius: 10px;
  background-color: #fff;
  padding-top: 30px;

  button {
    width: 100% !important;
    border-radius: 0 0 10px 10px !important;
  }
`;

const TitleSmall = styled.h4`
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 16px;
  font-weight: 300;
  letter-spacing: -0.5px;
  line-height: 28px;
`;

const Currency = styled.span`
  color: ${({ theme }) => theme.colors.dark};
  font-size: 30px;
  font-weight: 300;
  letter-spacing: -0.52px;
  line-height: 1;
  margin-bottom: 5px;
`;

const TimePer = styled.span`
  color: ${({ theme }) => theme.colors.dark};
  font-size: 30px;
  font-weight: 300;
  letter-spacing: -0.52px;
  line-height: 1;
  margin-bottom: 5px;
`;

const Pricing = () => {
  const [timeMonthly, setTimeMonthly] = useState(true);

  return (
    <>
      {/* <!-- Pricing section --> */}
      <SectionStyled bg="#F7F7FB" pt="90px !important" pb="0 !important">
        <Container
          className="position-relative"
          css={`
            z-index: 1;
          `}
        >
          <Row className="justify-content-center">
            <Col md="8" lg="9">
              <div className=" text-center">
                <Title>Pricing &amp; Plans</Title>
                <Text>
                  Unlimited Vehicles & New Contract Creation
                  <br className="d-none d-sm-block d-md-none d-lg-block" />{" "}
                  Included With All Accounts!
                </Text>
              </div>
            </Col>
          </Row>
          <div className="text-center pt-5">
            <div className="d-inline-flex justify-content-between align-items-center mb-5">
              <Text>Monthly</Text>

              <Switch onClick={() => setTimeMonthly(!timeMonthly)} />
              <div className="d-flex align-items-center">
                <Text>Yearly</Text>
                <Badge ml={2}>Save</Badge>
              </div>
            </div>

            <Row>
              <Col lg="4" className="mb-5">
                <CardPricing>
                  <div className="mb-4">
                    <TitleSmall>Starter Shop</TitleSmall>
                    <div className="d-flex align-items-end justify-content-center my-3">
                      <Currency>$</Currency>
                      <Title
                        css={`
                          font-size: 80px;
                          letter-spacing: -1.38px;
                          margin-bottom: 0 !important;
                        `}
                      >
                        {timeMonthly ? 49 : 45}
                      </Title>
                      <TimePer>/mo</TimePer>
                    </div>
                    <Text fontSize="18px">...</Text>
                    <ULStyled>
                      <li>Unlimited Vehicles</li>
                      <li>Unlimited New Contracts</li>
                      <li>No Setup Fees</li>
                      <li>Lifetime updates</li>
                      <li>25 Contracts History</li>
                    </ULStyled>
                  </div>
                  <a href="https://my.loanerhub.com/register">
                    <Button bg="secondary">Start 14 Days Free Trial</Button>
                  </a>
                </CardPricing>
              </Col>

              <Col lg="4" className="mb-5">
                <CardPricing>
                  <div className="mb-4">
                    <TitleSmall>Strong Loaner</TitleSmall>
                    <div className="d-flex align-items-end justify-content-center my-3">
                      <Currency>$</Currency>
                      <Title
                        css={`
                          font-size: 80px;
                          letter-spacing: -1.38px;
                          margin-bottom: 0 !important;
                        `}
                      >
                        {timeMonthly ? 99 : 95}
                      </Title>
                      <TimePer>/mo</TimePer>
                    </div>
                    <Text fontSize="18px">...</Text>
                    <ULStyled>
                      <li>Unlimited Vehicles</li>
                      <li>Unlimited New Contracts</li>
                      <li>No Setup Fees</li>
                      <li>Lifetime updates</li>
                      <li>
                        <b>100 Contracts History</b>
                      </li>
                      <li>
                        <b>Premium Support</b>
                      </li>
                    </ULStyled>
                  </div>
                  <a href="https://my.loanerhub.com/register">
                    <Button bg="primary">Start 14 Days Free Trial</Button>
                  </a>
                </CardPricing>
              </Col>

              <Col lg="4" className="mb-4">
                <CardPricing>
                  <div className="mb-4">
                    <TitleSmall>Active Fleet</TitleSmall>
                    <div className="d-flex align-items-end justify-content-center my-3">
                      <Currency>$</Currency>
                      <Title
                        css={`
                          font-size: 80px;
                          letter-spacing: -1.38px;
                          margin-bottom: 0 !important;
                        `}
                      >
                        {timeMonthly ? 199 : 189}
                      </Title>
                      <TimePer> /mo</TimePer>
                    </div>
                    <Text fontSize="18px">...</Text>
                    <ULStyled>
                      <li>Unlimited Vehicles</li>
                      <li>Unlimited New Contracts</li>
                      <li>No Setup Fees</li>
                      <li>Lifetime Updates</li>
                      <li>
                        <b>500 Contracts History</b>
                      </li>
                      <li>Premium Support</li>
                    </ULStyled>
                  </div>

                  <a href="https://my.loanerhub.com/register">
                    <Button bg="secondary">Start 14 Days Free Trial</Button>
                  </a>
                </CardPricing>
              </Col>
            </Row>
          </div>
        </Container>
      </SectionStyled>
    </>
  );
};

export default Pricing;
